import styles from './StartBgVideo.module.css';

import bgVideo from '../../assets/video/bgVideo1.webm';
import bgPoster from '../../assets/images/bgPoster1.webp';
import { useEffect, useRef } from 'react';

export const StartBgVideo = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    let timer = setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.classList.add(styles.unvisible);
      }
    }, 9560);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={styles.bgVideoWrapper} ref={videoRef}>
      <video playsInline autoPlay="autoplay" muted="muted" poster={bgPoster}>
        <source src={bgVideo} type="video/webm" />
      </video>
    </div>
  );
};
